// Display labels for an admission's payer / financial class.
//
// Two vocabularies reach the frontend because the two admission paths store the
// payer differently: the registration wizard writes finance_details.financial_class
// (CASH | CORP | TPA | INSURANCE | STAFF | GOVT_SCHEME — see
// patient-admission-ipd/constants/registrationConstants.js), while emergency-to-IPD
// writes the flat payer_type column (self_pay | insurance | corporate | government).
// The backend picks whichever is set (billing_payer_sync.effective_financial_class);
// this maps either spelling onto one display string.
export const PAYER_TYPE_LABELS = {
  cash:        "Self Pay",
  self_pay:    "Self Pay",
  insurance:   "Insurance",
  tpa:         "Insurance (TPA)",
  corp:        "Corporate",
  corporate:   "Corporate",
  govt_scheme: "Government Scheme",
  government:  "Government Scheme",
  staff:       "Staff",
};

export function payerTypeLabel(raw) {
  const key = String(raw || "").trim().toLowerCase();
  return PAYER_TYPE_LABELS[key] || (raw ? String(raw) : "");
}

// Label for the payer's *name*, which reads differently per class ("Insurer:
// Star Health" vs "Scheme: PM-JAY"). Self Pay and Staff have no payer name, so
// they return null and the caller prints no row at all.
export function payerDetailLabel(raw) {
  const key = String(raw || "").trim().toLowerCase();
  if (key === "insurance" || key === "tpa") return "Insurer";
  if (key === "corp" || key === "corporate") return "Corporate";
  if (key === "govt_scheme" || key === "government") return "Scheme";
  return null;
}
